import React, { useState } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import { API_URL } from '../config';
import EDSFooter from '../components/EDSFooter';
import { useSelector } from 'react-redux';

const Odzyskaj_haslo = () => {
    const history = useHistory();
    const userPasswordForgetURL = `${API_URL}UserPasswordForget`;
    const key = useSelector((state) => state.repos.chName);

    const [formData, setFromData] = useState({
        login: '',
        currentPurchaseKey: key
    });
    const save = (e) => {
        e.preventDefault();
        console.log(formData);
        localStorage.setItem('odzyskajLogin', formData.login);
        axios
            .post(userPasswordForgetURL, formData)
            .then((response) => {
                if (response.data.succeeded == 1) {
                    history.push('/odzyskaj_konto_wyslane');
                }
                console.log(response);
            })
            .catch(function (error) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.data.succeeded);
                console.log(error.response.data.token);
                console.log(error.response.data.message);
                if (
                    error.response.data.message == 'Nie znaleziono użytkownika / nieaktywne konto.'
                ) {
                    history.push('/odzyskaj_konto_wyslane');
                } else if (error.response.data.message == 'Błąd podczas przypomnienia hasła.') {
                    history.push('/error_przypominanie_hasla');
                }
            });
    };
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content">
                <a href="">
                    <Link to="/">
                        <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                    </Link>
                </a>
                <div className="half-half--reverse margin-top-64">
                    <main>
                        <section>
                            <h2 className="h2">Nie pamiętasz swojego hasła?</h2>
                            <p className="margin-top-32">
                                Podaj adres e-mail, którego użyłeś/łaś przy rejestracji, a my ....
                            </p>
                            <form
                                id="passrecovery"
                                method="post"
                                action=""
                                onSubmit={(e) => save(e)}
                            >
                                <div className="form__row margin-top-64">
                                    <label htmlFor="e-mail" className="form__label">
                                        E-mail
                                    </label>
                                    <input
                                        type="text"
                                        name="e-mail"
                                        id="e-mail"
                                        className="form__input"
                                        title="Podaj swój email"
                                        pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                                        onChange={(e) =>
                                            setFromData({
                                                ...formData,
                                                ...{ login: e.target.value },
                                            })
                                        }
                                        required
                                    />
                                </div>
                                <input
                                    type="submit"
                                    className="btn-primary margin-top-32 margin-bottom-32"
                                    value="Wyślij"
                                />
                            </form>
                        </section>
                    </main>
                    <div className="decorative">
                        <svg
                            width="320"
                            height="314"
                            viewBox="0 0 320 314"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M233.333 159.999C252.783 159.999 271.435 167.725 285.188 181.478C298.941 195.23 306.667 213.883 306.667 233.332C306.667 252.781 298.941 271.434 285.188 285.187C271.435 298.939 252.783 306.665 233.333 306.665C213.884 306.665 195.232 298.939 181.479 285.187C167.726 271.434 160 252.781 160 233.332C160 213.883 167.726 195.23 181.479 181.478C195.232 167.725 213.884 159.999 233.333 159.999V159.999ZM233.333 263.332C231.123 263.332 229.004 264.21 227.441 265.773C225.878 267.336 225 269.455 225 271.665C225 273.876 225.878 275.995 227.441 277.558C229.004 279.121 231.123 279.999 233.333 279.999C235.544 279.999 237.663 279.121 239.226 277.558C240.789 275.995 241.667 273.876 241.667 271.665C241.667 269.455 240.789 267.336 239.226 265.773C237.663 264.21 235.544 263.332 233.333 263.332V263.332ZM233.333 184.985C219.36 184.985 208.48 195.879 208.627 211.039C208.635 211.914 208.817 212.779 209.16 213.585C209.503 214.39 210.001 215.12 210.626 215.733C211.252 216.346 211.992 216.83 212.804 217.157C213.616 217.484 214.485 217.648 215.36 217.639C216.236 217.63 217.101 217.449 217.906 217.106C218.712 216.763 219.442 216.264 220.055 215.639C220.667 215.014 221.151 214.274 221.478 213.462C221.805 212.65 221.969 211.781 221.96 210.905C221.88 203.185 226.76 198.319 233.333 198.319C239.64 198.319 244.72 203.545 244.72 210.985C244.72 213.545 243.973 215.545 241.733 218.452L240.48 220.012L239.147 221.519L235.613 225.385L233.8 227.479C228.68 233.572 226.667 238.052 226.667 244.945C226.667 246.714 227.369 248.409 228.619 249.66C229.87 250.91 231.565 251.612 233.333 251.612C235.102 251.612 236.797 250.91 238.047 249.66C239.298 248.409 240 246.714 240 244.945C240 242.239 240.787 240.159 243.187 237.079L244.32 235.692L245.653 234.145L249.213 230.279L251 228.212C256.04 222.212 258.053 217.772 258.053 210.972C258.053 196.265 247.08 184.972 233.333 184.972V184.985ZM160.293 186.652C156.302 192.886 153.129 199.608 150.853 206.652H56.7067C55.3929 206.65 54.0918 206.908 52.8777 207.41C51.6637 207.912 50.5606 208.648 49.6317 209.577C48.7027 210.506 47.9662 211.609 47.4643 212.823C46.9624 214.037 46.7049 215.338 46.7066 216.652V224.345C46.7066 231.492 49.2667 238.399 53.9067 243.825C70.6133 263.399 96.8267 273.345 133.333 273.345C141.293 273.345 148.747 272.865 155.733 271.932C159 278.532 163.107 284.639 167.893 290.145C157.28 292.279 145.76 293.345 133.333 293.345C91.3867 293.345 59.5733 281.279 38.6933 256.812C30.9651 247.76 26.7196 236.248 26.72 224.345V216.652C26.7182 212.713 27.4926 208.812 28.9987 205.173C30.5049 201.533 32.7135 198.226 35.4982 195.44C38.2829 192.654 41.5891 190.444 45.2282 188.936C48.8672 187.428 52.7676 186.652 56.7067 186.652H160.307H160.293ZM133.333 26.7188C151.014 26.7188 167.971 33.7425 180.474 46.245C192.976 58.7474 200 75.7043 200 93.3854C200 111.067 192.976 128.023 180.474 140.526C167.971 153.028 151.014 160.052 133.333 160.052C115.652 160.052 98.6953 153.028 86.1929 140.526C73.6904 128.023 66.6667 111.067 66.6667 93.3854C66.6667 75.7043 73.6904 58.7474 86.1929 46.245C98.6953 33.7425 115.652 26.7188 133.333 26.7188V26.7188ZM133.333 46.7188C127.205 46.7188 121.137 47.9258 115.475 50.271C109.813 52.6163 104.668 56.0537 100.335 60.3871C96.0016 64.7205 92.5642 69.865 90.219 75.5269C87.8737 81.1887 86.6667 87.2571 86.6667 93.3854C86.6667 99.5138 87.8737 105.582 90.219 111.244C92.5642 116.906 96.0016 122.05 100.335 126.384C104.668 130.717 109.813 134.155 115.475 136.5C121.137 138.845 127.205 140.052 133.333 140.052C145.71 140.052 157.58 135.135 166.332 126.384C175.083 117.632 180 105.762 180 93.3854C180 81.0087 175.083 69.1388 166.332 60.3871C157.58 51.6354 145.71 46.7188 133.333 46.7188Z" />
                        </svg>
                    </div>
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Odzyskaj_haslo;
